/* eslint-disable no-console */
import { useEffect } from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles';
import { useDispatch, useSelector } from 'react-redux';
import { connectionStates } from '../../utils/app-configs';

export const handleSocketMessage = (socket, data, dispatch) => {
    console.log(`[SOCKET] - ${socket.eventType}:`, JSON.stringify(socket), JSON.stringify(data));
    if (socket.log) {
        socket.log(data);
    }
    if (socket.actions) {
        socket.actions.forEach(action => dispatch(action(data)));
    }
};

const useSockets = (sockets, featureFlags = []) => {
    const dispatch = useDispatch();
    const connection = useSelector(state => state.sockets.connection);

    useEffect(() => {
        if (
            featureFlags.some(ff => isToggleEnabled(ff)) &&
            connection?.state === connectionStates.Connected
        ) {
            sockets.forEach((socket) => {
                connection?.on(
                    socket.eventType,
                    data => handleSocketMessage(socket, data, dispatch),
                );
            });
        }
        return () => {
            if (
                featureFlags.some(ff => isToggleEnabled(ff)) &&
                connection?.state === connectionStates.Connected
            ) {
                sockets.forEach((socket) => {
                    connection?.off(socket.eventType);
                });
            }
        };
    }, [connection?.state]);

    return [connection.state];
};

export default useSockets;
